import {
  ToggleBlockType
} from './block-type'

export class HeaderSix extends ToggleBlockType {
  getBlockType = () => 'header-six'

  getButtonText = () => 'H6'
}



/** WEBPACK FOOTER **
 ** ./lib/toggle/block-type/header-six.js
 **/